import { useLayoutEffect } from "react";

function useScrollToTopOnMount() {
  useLayoutEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
}

export default useScrollToTopOnMount;
